import { render, staticRenderFns } from "./SociosEditarActividades.vue?vue&type=template&id=22cd203c&scoped=true&"
import script from "./SociosEditarActividades.vue?vue&type=script&lang=js&"
export * from "./SociosEditarActividades.vue?vue&type=script&lang=js&"
import style0 from "./SociosEditarActividades.vue?vue&type=style&index=0&id=22cd203c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd203c",
  null
  
)

export default component.exports